import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';

// import CONSTANTS from '../../_constants/constants';
import { environment } from '../../../environments/environment';
import { DefaultParams } from '../../_shared/interfaces/defaultParams';

import { UtilService } from '../../_shared/services/util.service';

import { Country } from './country.model';
import { State } from './state.model';
import { City } from './city.model';
import { District } from './district.model';

interface ExtendedDefaultParams extends DefaultParams {
  by_name?: any;
}

@Injectable({
  providedIn: 'root',
})
export class CountryService {
  constructor(private http: HttpClient, private utilService: UtilService) {}

  private apiUrl = environment.apiEndpoint + 'countries';

  getFilterCriteria() {
    let defaultParams: ExtendedDefaultParams = {
      page: 1,
      sortDir: 'asc',
      sortedBy: 'name',
    };

    return defaultParams;
  }

  getCountries(params = null): Observable<any> {
    if (!params) {
      params = this.getFilterCriteria();
    }

    let queryParams = new HttpParams({ fromObject: params });

    return this.http.get(this.apiUrl, { params: queryParams }).pipe(
      map((resp) => {
        if (resp['data']) {
          return {
            data: resp['data'],
            meta: this.utilService.getItemsMetaData(resp, this.getFilterCriteria()),
          };
        } else {
          return resp;
        }
      })
    );
  }

  getCountry(id: string, params = null): Observable<Country> {
    let queryParams = new HttpParams({ fromObject: params });

    return this.http.get<Country>(`${this.apiUrl}/${id}`, {
      params: queryParams,
    });
  }

  getTaxIdTypesByCountry(params = {}): Observable<any> {
    let queryParams = new HttpParams({ fromObject: params });

    return this.http.get(`${environment.apiEndpoint}country_settings/tax_id_types`, {
      params: queryParams,
    });
  }

  getActivityCodesByCountry(params = {}): Observable<any> {
    let queryParams = new HttpParams({ fromObject: params });

    return this.http.get(`${environment.apiEndpoint}country_settings/company_activity_codes`, {
      params: queryParams,
    });
  }

  getExonerationTypesByCountry(params = {}): Observable<any> {
    let queryParams = new HttpParams({ fromObject: params });

    return this.http.get(`${environment.apiEndpoint}country_settings/exoneration_types`, {
      params: queryParams,
    });
  }

  getStates(countryId, params = {}): Observable<any> {
    let queryParams = new HttpParams({ fromObject: params });

    return this.http.get<State[]>(`${this.apiUrl}/${countryId}/states`, { params: queryParams });
  }

  getCities(countryId, params = {}): Observable<any> {
    let queryParams = new HttpParams({ fromObject: params });

    return this.http.get<City[]>(`${this.apiUrl}/${countryId}/cities`, { params: queryParams });
  }

  getDistricts(countryId, params = {}): Observable<any> {
    let queryParams = new HttpParams({ fromObject: params });

    return this.http.get<District[]>(`${this.apiUrl}/${countryId}/districts`, {
      params: queryParams,
    });
  }
}
